export const SET_TIMER = 'SET_TIMER'
export const UNSET_TIMER = 'UNSET_TIMER'
